import { render } from "./ExtendEvent.vue?vue&type=template&id=141bfe0b&scoped=true"
import script from "./ExtendEvent.vue?vue&type=script&lang=js"
export * from "./ExtendEvent.vue?vue&type=script&lang=js"

import "./ExtendEvent.vue?vue&type=style&index=0&id=141bfe0b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-141bfe0b"

export default script